<template>
  <div class="support-service-view">
    <v-container>
      <Support_services />
    </v-container>
  </div>
</template>
  
<script>
import Support_services from "../components/Support_services/Support_services.vue";
  
export default {
  components: {
    Support_services,
  },
};
</script>

<style lang="scss" scoped>
.support-service-view {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  padding: 32px 0;
}

@media (max-width: 600px) {
  .support-service-view {
    padding: 24px 0;
  }
}
</style>
  